import { useEffect, useRef } from 'react'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBoxVertical/Types'
import { message } from 'antd'
import { YHModal } from '@/components/YHModal'
import { baseAuthModel } from '../authModel'
import { globalPrompt } from '@/components/message'
import { authService } from '../authService'
import useGlobalModel from '@/model/globalModel'

export const EditAuthModal = () => {
    const { editCarVisible, setEditCarVisible, loadData } = baseAuthModel()
    const formRef = useRef<IYhFormRef>()
    // const [formVal, setFormVal] = useState<any>({})
    const {
        user: { shopCode },
    } = useGlobalModel(({ user }) => [user])

    const onOk = () => {
        formRef.current?.validateFields().then(async (val) => {
            try {
                let { retData } = await authService.edit({
                    // ...editCarVisible.value,
                    // ...val,
                    id: editCarVisible.value.id,
                    pwd: val.pwd,
                    accountName: editCarVisible.value.accountName,
                    createUserId: shopCode,
                })
                setEditCarVisible({
                    visible: false,
                    value: {},
                })
                message.success(`修改成功！`)
                loadData()
                return retData
            } catch (error) {
                message.warning(error)
            }
        })
    }

    useEffect(() => {
        formRef.current?.setFieldsValue({ ...editCarVisible.value, pwd: '' })
    }, [editCarVisible.value])

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }) => {
        formRef.current?.setFieldsValue(val)
        // setFormVal({ ...formVal, ...val })
    }

    const formItem: IYhFormItemsBox = {
        title: '',
        style: { padding: '10px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '用户账户',
                fieldName: 'accountName',
                span: 24,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '用户名称',
                fieldName: 'name',
                span: 24,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Password,
                fieldLabel: '新密码',
                fieldName: 'pwd',
                span: 24,
            },
        ],
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues)
    }

    const FromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        // formValues: formVal,
        onChange,
        boxs: [formItem],
    }
    const onClose = () => {
        globalPrompt('modal', {
            title: '修改密码',
            type: 'warning',
            text: '您正在修改的密码记录还没保存...是否关闭？',
            okText: '确认关闭',
            onOk: () =>
                setEditCarVisible({
                    visible: false,
                    value: {},
                }),
            cancelText: '继续修改',
            // onCancel: () => {
            //     formRef.current?.resetFields()
            //     return
            // },
        })
    }
    return (
        <YHModal
            visible={editCarVisible.visible}
            title="您正在修改密码..."
            cancelText="取消修改"
            okText="确定修改"
            onCancel={onClose}
            onOk={onOk}
            width={500}
            showFooter={true}
        >
            <YhFormBox {...FromConfig} isShowHeader={false} />
        </YHModal>
    )
}
